/**
 * Rotas da tela Gerenciar (legado hash router: /ecommerce/...).
 * patientKey = referência FHIR (Patient/{id}), sempre no splat para aceitar "/".
 * @module ecommerceManageRoutes
 */

import type { Patient } from "fhir/r5";
import { ecommercePatientReference } from "./patientEcommerceOpState";

export const ECOMMERCE_LIST_PATH = "/ecommerce";
export const ECOMMERCE_MANAGE_SEGMENT = "gerenciar";

export interface EcommerceManageLocationState {
  patient?: Patient;
  listSearch?: string;
}

export interface EcommerceManageRouteParams {
  patientKey: string;
  transactionId?: string;
}

function decodePathSegment(value: string): string {
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
}

export function buildEcommerceManagePath(
  patient: Patient,
  transactionId?: string,
): string {
  const reference = ecommercePatientReference(patient);
  const encodedKey = encodeURIComponent(reference);
  const base = `${ECOMMERCE_LIST_PATH}/${ECOMMERCE_MANAGE_SEGMENT}/${encodedKey}`;
  if (!transactionId) return base;
  return `${base}/${encodeURIComponent(transactionId)}`;
}

export function parseEcommerceManageSplat(
  splat: string | undefined,
): EcommerceManageRouteParams {
  const parts = (splat || "")
    .split("/")
    .map((part) => part.trim())
    .filter(Boolean)
    .map(decodePathSegment);

  if (parts[0] === ECOMMERCE_MANAGE_SEGMENT) {
    parts.shift();
  }

  if (parts[0] === "Patient" && parts[1]) {
    return {
      patientKey: `Patient/${parts[1]}`,
      transactionId: parts[2] || undefined,
    };
  }

  return {
    patientKey: parts[0] || "",
    transactionId: parts[1] || undefined,
  };
}

export function matchesEcommercePatientKey(
  patient: Patient,
  patientKey: string,
): boolean {
  const reference = ecommercePatientReference(patient);
  if (!patientKey || !reference) return false;
  return reference === patientKey;
}
